import { createAsyncThunk } from '@reduxjs/toolkit';

import { selectWorkCalendarRecordsArray } from 'store/records/selectors/records-base.selectors';
import { selectSelectedRecordsIds } from 'store/records/selectors/records.selectors';
import { selectUserActiveEmployerId } from 'store/user/selectors.js/user.selectors';

export const openSendToApprovalDialog = createAsyncThunk(
  'approvals/OpenSendToApprovalDialog',
  async (_, { getState }) => {
    const selectedEmployerIdByNavigation = selectUserActiveEmployerId(
      getState()
    );

    const selectedRecordsIds = selectSelectedRecordsIds(getState());

    const selectedRecords = selectWorkCalendarRecordsArray(getState()).filter(
      (record) => selectedRecordsIds.includes(record.id)
    );

    const selectedRecordsProjectId = selectedRecords[0].project;

    const initialDialogData = {
      employerId: selectedEmployerIdByNavigation,
      projectId: selectedRecordsProjectId,
      approvers: [],
    };

    return initialDialogData;
  }
);
